"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _useObjectState = _interopRequireDefault(require("./useObjectState"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useFormRequest = _ref => {
  let {
    preventDefault = true,
    defaultDataState = {},
    apiRequest: passedApiRequest,
    transformResponse = response => response,
    onRequestStart = () => {},
    onRequestComplete = () => {},
    onError = error => error,
    onSuccess = transformedResponse => transformedResponse
  } = _ref;
  const [requestError, setRequestError] = (0, _react.useState)(null);
  const [successResponse, setSuccessResponse] = (0, _react.useState)(null);
  const [requestInProgress, setRequestInProgress] = (0, _react.useState)(false);
  const [data, mutateData, setData] = (0, _useObjectState.default)(defaultDataState);
  const apiRequest = async function () {
    onRequestStart();
    setRequestError(null);
    setSuccessResponse(null);
    setRequestInProgress(true);
    const [error, response] = await passedApiRequest(...arguments);
    if (!error && response) {
      setSuccessResponse(response);
      onSuccess(transformResponse(response));
    } else {
      setRequestError(error);
      onError(error);
    }
    setRequestInProgress(false);
    onRequestComplete();
  };
  const onFormSubmit = function (e) {
    if (e && preventDefault && e.preventDefault) {
      e.preventDefault();
    }
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    apiRequest(...args);
  };
  return {
    data,
    setData,
    mutateData,
    apiRequest,
    requestError,
    onFormSubmit,
    successResponse,
    requestInProgress
  };
};
var _default = exports.default = useFormRequest;